import { differenceInSeconds } from 'date-fns';
import { useRef } from 'react';

import { Badge } from '@flipster/react/design-system/badge';
import { CountdownDate } from '@flipster/react/design-utils/countdown-date';
import TrendIcon from '@flipster/react/icon/generated/TrendIcon';

interface Props {
  targetDate: Date;
  onEnd: () => void;
}

export const ProfitCountDown = ({ targetDate, onEnd }: Props) => {
  const initialTargetDate = useRef(targetDate);
  const isWarning = differenceInSeconds(initialTargetDate.current, new Date()) < 60;

  return (
    <Badge type='tint' color={isWarning ? 'warning' : 'promotion'} leadingIcon={<TrendIcon size={12} />}>
      <CountdownDate
        targetDate={initialTargetDate.current}
        format='${mm}:${ss}'
        onEnd={onEnd}
        css={{ textStyle: 'Text/XS/Monospace/Regular' }}
      />
    </Badge>
  );
};
